module.exports = __webpack_public_path__ + "static/media/NewFeatures_Jan5.a774e462.png";